import { ExperimentEditor } from "./components/ExperimentEditor/ExperimentEditor";

export default function App() {
  return <ExperimentEditor />;
}
